module.exports = {
    "Анонсы": "Анонстар",
    "Главная": "Басты",
    "Льгот": "Жеңілдік",
    "Статус": "Мәртебе",
    "Телефон": "Ұялы телефон",
    "E-mail": "E-mail",
    "Адрес": "Мекен-жайы",
    "Дата рождения": "Туған күні",
    "ФИО": "ТАӘ",
    "ИИН": "ЖСН",
    "Основная информация": "Негізгі ақпарат",
    "Ваш статус": "Сіздің мәртебеңіз",
    "место в общей очереди": "жалпы кезектегі орыны",
    "место в очереди по категории": "санаты бойынша кезектегі орын",
    "Выход": "Шығу",
    "Место собеседования": "Сұхбат орны",
    "Комментарий": "Комментарий",
    "Дата собеседования": "Сұхбат күні",
    "Адрес компании": "Компанияның мекен-жайы",
    "Название компании": "Компанияның атауы",
    "История собеседования": "Сұхбат тарихы",
    "Очередь в категории": "Санаттағы кезегі:",
    "Загрузить еще": "Тағы жүктеу",
    "Подробнее": "Толығырақ",
    "Войти": "Кіру",
    "Введите пароль": "Құпия сөзді енгізіңіз",
    "Пароль": "Құпия сөз",
    "Выберите ЭЦП": "ЭЦҚ-ны таңдаңыз",
    "Добро пожаловать в Личный кабинет!": "Жеке кабинетке қош келдіңіз!",
    "Очередь в общем списке": "Жалпы тізімдегі кезегі",
    "<b>Сіз жұмыссыздар тізіміне тіркелгендер кезегінде жоқсыз.</b><br>Кезекке тіркелу үшін  <a href='/reg.html'>Өтінім жолдау</a> қажет.": "<b>Сіз жұмыссыздар тізіміне тіркелгендер кезегінде жоқсыз.</b><br>Кезекке тіркелу үшін  <a href='/reg.html'>Өтінім жолдау</a> қажет."
}